import { Wrapper } from "@Src/layout/Wrapper";
import type { Resource } from "@Src/resources/resources_config";
import { resourceName } from "@Src/resources/settings/name";
import { SettingsList } from "@Src/resources/settings/SettingsList";
import SettingsIcon from "@mui/icons-material/Settings";

const resource: Resource = {
	list: Wrapper(resourceName.name, "list", SettingsList),
	icon: SettingsIcon,
	name: resourceName.name,
	path: `/${resourceName.name}`,
	apiPath: "settings/settings",
};

export default resource;
